import { useState, useEffect } from "react";

const useMultiSelect = (
  options,
  userTypeData = {},
  merchantData = {},
  dateRange = {},
  fetchData = () => { },
  isAllSelected = true
) => {
  // If isAllSelected is true, start with all options selected; otherwise start with none
  const [selectedItems, setSelectedItems] = useState(
    isAllSelected ? options : []
  );
  const [allOptionSelected, setAllOptionSelected] = useState(isAllSelected);

  useEffect(() => {
    if (isAllSelected) {
      setSelectedItems(options);
      setAllOptionSelected(true);
    } else {
      // When not selecting all by default, keep current selections if possible
      // but ensure we drop any items that are no longer in options
      setSelectedItems((prev) =>
        prev.filter((item) => options.some((opt) => opt.id === item.id))
      );
      if (!options.length) {
        setAllOptionSelected(false);
      }
    }
  }, [options, isAllSelected]);

  const handleOptionClick = (selectedItem) => {
    if (selectedItem === "All") {
      if (selectedItems.length === options.length) {
        // Deselect all
        setSelectedItems([]);
        setAllOptionSelected(false);
      } else {
        // Select all
        const selectAll = options.map((item) => ({ ...item }));
        setAllOptionSelected(true);
        setSelectedItems(selectAll);
        updateData([]);
      }
    } else {
      const matchesItem = (item, target) =>
        (item.id !== undefined && target.id !== undefined && String(item.id) === String(target.id)) ||
        (item.title !== undefined && target.title !== undefined && item.title === target.title);

      const isSelected = selectedItems?.some((item) => matchesItem(item, selectedItem));
      if (isSelected) {
        // Deselect the specific item
        const updatedItems = selectedItems.filter((item) => !matchesItem(item, selectedItem));

        setSelectedItems(updatedItems);
        setAllOptionSelected(false);
        updateData(updatedItems);
      } else {
        // Select the specific item (avoid duplicate)
        const alreadyInList = selectedItems?.some((item) => matchesItem(item, selectedItem));
        const updatedItems = alreadyInList ? selectedItems : [...selectedItems, selectedItem];
        const allSelected = updatedItems.length === options.length;
        setSelectedItems(updatedItems);
        setAllOptionSelected(allSelected && options.length > 1 ? true : false);
        updateData(updatedItems);
      }
    }
  };
  // -------------------------get all record based on selected checkbox---------

  const clearAll = () => {
    setSelectedItems([]);
    setAllOptionSelected(false);
  };

  // Allow programmatic selection from parent components without relying on click toggling logic.
  const setSelectedItemsExternal = (items) => {
    const safeItems = Array.isArray(items) ? items : [];
    setSelectedItems(safeItems);
    setAllOptionSelected(safeItems.length === options.length && options.length > 0);
  };

  const handleGetAllCheckboxId = (selectedData) => {
    let selectAllId = [];
    if (selectedData === "All") {
      if (selectedItems.length !== options.length) {
        let getCheckedAllId = options.map((item) => item);
        selectAllId = selectAllId.concat(selectAllId, ...getCheckedAllId);
        setAllOptionSelected(true);
      } else {
        selectAllId = [];
        setAllOptionSelected(false);
      }
    } else {
      selectAllId = selectedItems.includes(selectedData)
        ? selectedItems.filter((item) => item !== selectedData)
        : selectAllId.concat(selectedItems, selectedData);
      if (selectAllId.length === options.length) {
        setAllOptionSelected(true);
      } else {
        setAllOptionSelected(false);
      }
    }

    // const result =
    //   selectAllId.length > 0
    //     ? selectAllId.map((item) => item.title).join(", ")
    //     : "All";
    setSelectedItems(selectAllId);
    // console.log("result", result);
  };

  // -------------------------get all record based on selected checkbox---------

  const updateData = (updatedItems) => {
    const data = {
      ...userTypeData,
      cat_id: updatedItems.map((item) => item.id).toString(),
      merchant_id: merchantData?.data?.merchant_id,
      start_date: dateRange?.start_date,
      end_date: dateRange?.end_date,
    };
    // if (data) {
    //   fetchData(data);
    // }
  };

  return {
    selectedItems,
    allOptionSelected,
    handleOptionClick,
    handleGetAllCheckboxId,
    clearAll,
    setSelectedItemsExternal,
    setSelectedItems,
    setAllOptionSelected,
    options,
  };
};

export default useMultiSelect;
